import { jsx as e } from "react/jsx-runtime";
import { Flex as t, Spinner as i } from "@chakra-ui/react";
import { useSavedListProvider as n } from "../SavedList.context.es.js";
const m = () => {
  const { enableFooterLoader: r, isLoading: o } = n();
  return r && o ? /* @__PURE__ */ e(t, { paddingY: 4, justifyContent: "center", children: /* @__PURE__ */ e(i, { boxSize: 4 }) }) : null;
};
export {
  m as SavedListFooter
};
//# sourceMappingURL=SavedListFooter.es.js.map
